import React from 'react';
import SignUpFormComponent from "sign_up/app/component/sign_up_form";
import {HashRouter as Router, Route, Switch} from "react-router-dom";
import LoginFormComponent from "../../js/app/sign_up/app/component/login_form";
import Footer from '../main/modules/footer'
import ResetPasswordFormComponent from "../../js/app/sign_up/app/component/reset_password_form";
import Config from '../../js/app/main/app/service/config';

export default props => {
    const isSbBrandingAllowed = Config.get('is_sb_branding_allowed');
    return (
        <Router>
            <header className="header">
                { isSbBrandingAllowed && <div className="header__logo">
                    <a href='https://simplybook.pro/en/' target='_blank'>
                        <img alt={'logo'} src = "/v2/images/cluster/header/logo.svg" />
                    </a>
                </div> }
            </header>

            <section className="main-container__content">
                <Switch>
                    <Route path="/sign-up">
                        <SignUpFormComponent
                            recaptchaKey={props.config.recaptchaKey}
                            defaultCountry={props.config.defaultCountry}
                        />
                    </Route>
                    <Route path="/reset-password">
                        <ResetPasswordFormComponent
                            cluster={props.config.clusterLogin}
                        />
                    </Route>
                    <Route path="/">
                        <LoginFormComponent
                            cluster={props.config.clusterLogin}
                        />
                    </Route>
                </Switch>
            </section>

            <Footer/>
        </Router>
    );
};